// this function returns the maturity amount of fixed deposit
export function calculateFixedDeposit(
  investmentAmount,
  returnRate,
  year,
  month
) {
  const durationInMonths = year * 12 + month;
  const returnRateInMonth = returnRate / 1200;
  const calculatedData = Math.pow(1 + returnRateInMonth, durationInMonths);
  return investmentAmount * calculatedData;
}

export function calculateReverseSIP(expectedAmount, returnRate, year, month) {
  const totalCI = expectedAmount;
  const rate = returnRate / 100;
  const durInMonth = year * 12 + month;
  let t, i, monthlyAmt, result, profit, investedAmount;
  t = 0;
  monthlyAmt = 0;
  if (year === 0) {
    profit = 0;
    result = totalCI;
    investedAmount = totalCI;
  } else {
    for (i = durInMonth; i >= 1; i--) {
      t = Math.pow(1 + rate / 12, i);
      monthlyAmt = monthlyAmt + t;
    }
    result = totalCI / monthlyAmt;
    investedAmount = result * durInMonth;
    profit = totalCI - investedAmount;
  }
  return result;
}

// SIP and lumpsum cacl

function futureValue(rate, amount, period) {
  return amount * Math.pow(1 + rate / 100, period);
}

export function lumpsumFutureValue(rate, amount, period) {
  period = period;
  rate = rate;
  return Math.round(futureValue(rate, amount, period));
}

export function sipFutureValue(rate, amount, period) {
  let sip_value = 0;
  period = period * 12;
  rate = rate / 12;
  let periodIterator = period;
  for (let i = 1; i <= period; i++) {
    sip_value += futureValue(rate, amount, periodIterator);
    periodIterator = periodIterator - 1;
  }
  return Math.round(sip_value);
}

export function sipFutureValueYearly(rate, amount, period) {
  let sip_value = 0;
  let periodIterator = period;
  for (let i = 1; i <= period; i++) {
    sip_value += futureValue(rate, amount, periodIterator);
    periodIterator = periodIterator - 1;
  }
  return Math.round(sip_value);
}

export function stepUpSipFutureValue(rateStr, amountStr, periodStr, stepUpStr) {
  let rate = Number(rateStr);
  let amount = Number(amountStr);
  let period = Number(periodStr);
  let stepUp = Number(stepUpStr);

  let investmentAmount = amount;
  let investmentAmountFinal = 0;
  let totalAmount = 0;
  let totalMonths = period * 12;
  let i = 0;
  for (i = 0; i < Math.ceil(period); i++) {
    if (totalMonths >= 12) {
      let stepUpAnnualPeriodInYear = 1;

      totalAmount =
        lumpsumFutureValue(rate, totalAmount, 1) +
        sipFutureValue(rate, investmentAmount, stepUpAnnualPeriodInYear);
      investmentAmountFinal += investmentAmount * 12;
      investmentAmount = investmentAmount + investmentAmount * (stepUp / 100);
      totalMonths = totalMonths - 12;
    } else {
      let stepUpAnnualPeriodInYear = totalMonths / 12;
      totalAmount +=
        lumpsumFutureValue(rate, totalAmount, 1) +
        sipFutureValue(rate, investmentAmount, stepUpAnnualPeriodInYear);
      investmentAmountFinal += investmentAmount * totalMonths;
    }
  }

  return { totalAmount, investmentAmountFinal };
}

export function reccuringDepositFutureValue(rate, amount, period) {
  let rd_value = 0;
  period = period * 12;
  rate = rate / 12;
  let periodIterator = period;
  for (let i = 1; i <= period; i++) {
    rd_value += futureValue(rate, amount, periodIterator);
    periodIterator = periodIterator - 1;
  }
  return Math.round(rd_value);
}

export function npsFutureValue(
  age,
  investmentAmount,
  returnRate,
  annuity,
  annuityRate
) {
  let investmentTime = 60 - age;
  let totalAmount = investmentAmount * 12 * investmentTime;
  let compoundedAmount = Math.round(
    sipFutureValue(returnRate, investmentAmount, investmentTime)
  );
  let annuityAmount = Math.round(
    Number(compoundedAmount * annuity * annuityRate) / (100 * 100 * 12)
  );
  return { compoundedAmount, annuityAmount };
}

export function ssyFutureValue(investmentAmount) {
  let annualAmount = investmentAmount;
  let amountAfterFifteenYears = Math.round(
    ssyFutureValueFifteenYears(8.3, annualAmount, 14)
  );
  let amountAfterTwentyOneYears = Math.round(
    lumpsumFutureValue(8.3, amountAfterFifteenYears, 7)
  ); //Multiply and Divide by 12 to make it compound Annually rather monthly
  return { amountAfterTwentyOneYears, investmentAmount };
}

export function ssyFutureValueFifteenYears(rate, amount, period) {
  let sip_value = 0;
  period = period;
  rate = rate;
  let periodIterator = period;
  for (let i = 1; i <= period; i++) {
    sip_value += futureValue(rate, amount, periodIterator);
    periodIterator = periodIterator - 1;
  }
  return Math.round(sip_value);
}

export function swpFutureValue(investmentAmount, returnRate, withdrawal, year) {
  let futureValue = investmentAmount;
  let totalMonths = year * 12;
  const expectedReturnRate = (returnRate / 12) * 0.01;
  let interestEarned = 0;
  for (let currMonth = 0; currMonth < totalMonths; currMonth++) {
    const diff = futureValue - withdrawal;
    const interest = diff * expectedReturnRate;
    interestEarned += interest;
    futureValue = diff + interest;
  }
  return {
    futureValue,
    investmentAmount,
    interestEarned,
    returnRate,
    withdrawal,
    year
  };
}
